import React from 'react';
import { useInView } from 'react-intersection-observer';

const Images = ({ sources, loading = "lazy", alt = "", src, ...props }) => {

  const { ref, inView } = useInView({
    triggerOnce: true,
    threshold: 0.1,
    rootMargin: '50px',
    skip: loading === "eager",
  });

  const isVisible = loading === "eager" || inView;

  // Si es un objeto de Prismic, crear array de sources
  if (sources && typeof sources === 'object' && !Array.isArray(sources)) {
    
    if (!isVisible) {
      return (
        <div 
          ref={ref}
          style={{
            width: '100%',
            height: '200px',
            backgroundColor: '#f0f0f0',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            color: '#ccc'
          }}
        >
          Cargando...
        </div>
      );
    }

    return (
      <picture>
        {sources.mb && sources.mb.url && (
          <source srcSet={sources.mb.url} media="(max-width: 767px)" />
        )}
        {sources.sm && sources.sm.url && (
          <source srcSet={sources.sm.url} media="(max-width: 1023px)" />
        )}
        {sources.md && sources.md.url && (
          <source srcSet={sources.md.url} media="(max-width: 1365px)" />
        )}
        {sources.lg && sources.lg.url && (
          <source srcSet={sources.lg.url} media="(max-width: 1919px)" />
        )}
        <img
          src={sources.url || sources.lg.url || sources.md.url || sources.sm.url || sources.mb.url}
          alt={alt || "Image"}
          width="auto"
          height="auto"
          loading={loading}
          {...props}
        />
      </picture>
    );
  }

  // Si es una URL simple, usarla directamente
  if (src && typeof src === 'string') {
    
    if (!isVisible) {
      return (
        <div 
          ref={ref}
          style={{
            width: '100%',
            height: '200px',
            backgroundColor: '#f0f0f0'
          }}
        />
      );
    }

    return (
      <img
        src={src}
        alt={alt || "Image"}
        width="auto"
        height="auto"
        loading={loading}
        {...props}
      />
    );
  }
};

export default Images;
